import { useI18n as D } from "next-localization";
import { getFormattedDate as r, DATE_TIME_MINUTES_AM_FORMAT as f, DATE_MONTH_DAY_YEAR_TWO_DIGIT as p } from "../utils/date-time/index.js";
function M(n, c) {
  var a, s;
  const T = D(), i = c || T.t, t = (a = (/* @__PURE__ */ new Date()).toString().match(/\(([A-Za-z\s].*)\)/)) == null ? void 0 : a[1], e = ((s = t == null ? void 0 : t.match(/\b(\w)/g)) == null ? void 0 : s.join("")) ?? "", o = r(n, f), m = r(n, p), A = " ", _ = i("Header.ERWaitTimes.AsOfTime", {
    time: o,
    timezone: e
  }), E = `${A}${i("Header.ERWaitTimes.Timestamp", {
    time: o,
    timezone: e,
    date: m,
    interpolation: { prefix: "{", suffix: "}" }
  })}`;
  return {
    time: o,
    date: m,
    tzAcronym: e,
    timeStamp: _,
    timeStampWithDate: E
  };
}
export {
  M as u
};
